var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenIconEditProfileUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_933_2611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2001 22.8871H8.80001C8.3584 22.8871 8 22.5287 8 22.0871C8 21.6455 8.3584 21.2871 8.80001 21.2871H23.2001C23.6418 21.2871 24.0002 21.6455 24.0002 22.0871C24.0002 22.5287 23.6418 22.8871 23.2001 22.8871Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.799787 22.8873C0.589629 22.8873 0.385916 22.8053 0.234352 22.6527C0.0380604 22.4565 -0.0418233 22.1738 0.021068 21.9039L1.18378 16.9705C1.21796 16.8255 1.29139 16.6931 1.39706 16.5886L16.1054 1.88026C17.0101 0.974583 18.5929 0.972434 19.4996 1.88026L21.008 3.38848C21.4613 3.8418 21.7109 4.44454 21.7109 5.08556C21.7109 5.72678 21.4613 6.3305 21.008 6.78265L6.29946 21.49C6.19399 21.5957 6.06156 21.6693 5.91762 21.7033L0.984164 22.866C0.922445 22.8811 0.86053 22.8873 0.799787 22.8873ZM2.68887 17.5584L1.87499 21.0121L5.32894 20.1982L19.8762 5.651C20.0277 5.49944 20.1109 5.29904 20.1109 5.08556C20.1109 4.87228 20.0277 4.67072 19.8762 4.52032L18.3679 3.01093C18.066 2.70898 17.5381 2.70898 17.2373 3.01093L2.68887 17.5584ZM5.73304 20.9248H5.74379H5.73304Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2146 10.2428C17.0099 10.2428 16.805 10.1649 16.6494 10.008L12.8774 6.23629C12.5649 5.92379 12.5649 5.41714 12.8774 5.10464C13.1901 4.79194 13.6968 4.79194 14.0093 5.10464L17.781 8.87636C18.0935 9.18886 18.0935 9.69551 17.781 10.008C17.6242 10.1649 17.4195 10.2428 17.2146 10.2428Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_933_2611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIconEditProfileUser);
export default __webpack_public_path__ + "static/media/pen-icon-edit-profile-user.b769f44d9385c29529bd7586970e5da1.svg";
export { ForwardRef as ReactComponent };